module.exports = __webpack_public_path__ + "img/xitun-photo.d00c53b6.png";